<template>
  <div class="calendar-details">
    <div class="calendar-details__info">
      <div class="repayment-head">
        <StatusBanner
          v-if="isOverdue"
          type="negative"
          :title="$t`Вы на просрочке` + '!'"
          :subtitle="$t`Оплатите счет сегодня`"
          :amount="$currencyFormatter(data.left_to_pay_total_sum)"
        />
        <template v-else>
          <Divider />
          <StatusBanner
            :title="$t`К оплате`"
            :subtitle="dateText"
            :amount="$currencyFormatter(data.left_to_pay_total_sum)"
          />
          <Divider />
        </template>
      </div>
    </div>
    <HistoryItems :items="historyItems" />
  </div>
</template>

<script>
import { getDateText } from "@/utils/date";
import Divider from "@/components/shared/divider/Divider.vue";
import StatusBanner from "@/components/bills-calendar/StatusBanner.vue";
import HistoryItems from "@/components/bills-calendar/CalendarHistoryItems.vue";

export default {
  components: {
    Divider,
    HistoryItems,
    StatusBanner,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    historyItems: {
      type: [Array, null],
      required: true,
    },
    simpleId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isOverdue() {
      return ["OVERDUE", "WAS_OVERDUE"].includes(this.data?.status);
    },
    dateText() {
      return this.$l10nformat(this.$t`Оплатите счет до #DATE#`, {
        DATE: getDateText(this.data.pay_until_date, "dative"),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.repayment-head {
  position: sticky;
  top: 0;
  width: 100%;

  &__date {
    padding-bottom: 15px;
    text-align: left;
  }

  &__amount {
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.calendar-details {
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  &__info {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: white;
  }

  &__wrapper {
    position: relative;
    padding-bottom: 34px;
    width: 100vw;
    overflow: hidden;
  }

  &__history {
    margin-bottom: -15px;
    overflow: scroll;
  }
}
</style>
